// extracted by mini-css-extract-plugin
export var article_content = "article-module--article_content--35491";
export var article_title = "article-module--article_title--be63d";
export var catagory = "article-module--catagory--6c034";
export var container = "article-module--container--b134a";
export var date = "article-module--date--606a3";
export var info = "article-module--info--16d55";
export var time = "article-module--time--db241";